export default {
  namespaced: true,
  state: {
    StoreVendorsMap: {
      visible: false,
      activeVendor: {
        id: undefined,
      },
    },
  },
  getters: {
    showVendorsMap(state) {
      return state.StoreVendorsMap.visible;
    },
    activeVendor(state) {
      return state.StoreVendorsMap.activeVendor;
    },
  },
  actions: {
    setVendorsMapVisibility: (context, data) => {
      context.commit("setVendorsMapVisibility", data);
    },
    setActiveVendor: (context, data) => {
      context.commit("setActiveVendor", data);
    },
  },
  mutations: {
    setVendorsMapVisibility: (state, bool) => {
      state.StoreVendorsMap.visible = bool;
    },
    setActiveVendor: (state, vendor) => {
      state.StoreVendorsMap.activeVendor = vendor;
    },
  },
};
